export enum PillarThree {
    START_OBS_CLICK = 'pillarThree.startObsClick',
    START_OBS_YES_CLICK = 'pillarThree.startObsYesClick',
    START_OBS_NO_CLICK = 'pillarThree.startObsNoClick',
    START_OBS_DISMISS = 'pillarThree.startObsDismiss',
    START_CMT_CLICK = 'pillarThree.startCmtClick',
    START_CMT_YES_CLICK = 'pillarThree.startCmtYesClick',
    START_CMT_NO_CLICK = 'pillarThree.startCmtNoClick',
    START_CMT_DISMISS = 'pillarThree.startCmtDismiss',
}
